<template lang="pug">
    .ma-sm-2
        .text-center(v-if="isLoading")
            v-progress-circular(
                :size='100'
                :width='10'
                color='var(--volie-blue)'
                indeterminate
                style="margin-top: 100px;"
            )

        v-alert(
            v-else-if="renderCampaignDispositionError"
            dark
            dense
            type="error"
        )
            | Unable to find any dispositions

        v-container.overflow-y-auto(v-else)
            v-row(align="center")
                v-col(cols='12')
                    v-form
                        v-container(v-if="(mostRecentlyUsedDispositions.length > 0 || mostUsedDispositions.length > 0)" class="mb-8")
                            template(v-if="currentUserHasColumnDispositionsView")
                                v-row
                                    v-col(:cols="6").pl-0
                                        .subtitle-1.font-weight-medium.text-left(style="line-height: 1.2") Most Used
                                        v-chip-group(
                                            column
                                            dense
                                        )
                                            DispositionSelectChip(
                                                v-for="disposition in mostUsedDispositions"
                                                :key="disposition.campaign_disposition_id"
                                                :disposition="disposition"
                                                :selected="communicationDisposition?.campaign_disposition_id === disposition.campaign_disposition_id"
                                                @click="handleDispositionBtnSelect(disposition)"
                                            )
                                    v-col(:cols="6").pl-0
                                        .subtitle-1.font-weight-medium.text-left(style="line-height: 1.2") Recently Used
                                        v-chip-group(
                                            column
                                            dense
                                        )
                                            DispositionSelectChip(
                                                v-for="disposition in mostRecentlyUsedDispositions"
                                                :key="disposition.campaign_disposition_id"
                                                :disposition="disposition"
                                                :selected="communicationDisposition?.campaign_disposition_id === disposition.campaign_disposition_id"
                                                @click="handleDispositionBtnSelect(disposition)"
                                            )
                            template(v-else)
                                v-row.pl-0.mb-4
                                    .subtitle-1.font-weight-medium.text-left(style="line-height: 1.2") Most Used Dispositions
                                    v-chip-group(
                                        column
                                        dense
                                    )
                                        DispositionSelectChip(
                                            v-for="disposition in mostUsedDispositions"
                                            :key="disposition.campaign_disposition_id"
                                            :disposition="disposition"
                                            :selected="communicationDisposition?.campaign_disposition_id === disposition.campaign_disposition_id"
                                            @click="handleDispositionBtnSelect(disposition)"
                                        )
                                v-row.pl-0
                                    .subtitle-1.font-weight-medium.text-left(style="line-height: 1.2") Recently Used Dispositions
                                    v-chip-group(
                                        column
                                        dense
                                    )
                                        DispositionSelectChip(
                                            v-for="disposition in mostRecentlyUsedDispositions"
                                            :key="disposition.campaign_disposition_id"
                                            :disposition="disposition"
                                            :selected="communicationDisposition?.campaign_disposition_id === disposition.campaign_disposition_id"
                                            @click="handleDispositionBtnSelect(disposition)"
                                        )
            
                        v-chip(
                            v-if="renderAlertOfLinkedDispositionFromPreviousAction"
                            small
                            outlined
                            color="info"
                            class="mb-2 d-flex justify-center mx-auto"
                            style="width: fit-content;"
                        )
                            v-icon(left small) mdi-link-variant
                            | Linked to previous disposition
                        
                        template(v-if="campaignDispositionMode === 'advanced'")
                            v-autocomplete(
                                :items='campaignDispositionGroups'
                                item-text="disposition_group_name"
                                item-value="campaign_disposition_group_id"
                                :loading="isLoadingCampaignDispositionGroups"
                                label='Disposition Group'
                                outlined
                                prepend-inner-icon="mdi-pencil"
                                v-model="currentSelectedCampaignDispositionGroupId"
                                dense
                            )
                        v-autocomplete(
                            :items='sortedCampaignDispositionsForDropdown'
                            item-text="disposition_description"
                            item-value="campaign_disposition_id"
                            :loading="campaignDispositionMap[currentSelectedCampaignDispositionGroupId || 0]?.isLoading"
                            :disabled="campaignDispositionsDropdownDisabled"
                            label='Disposition'
                            outlined
                            prepend-inner-icon="mdi-pencil"
                            v-model="communicationDisposition.campaign_disposition_id"
                            v-on:change="handleCampaignDispositionSelectChange"
                            dense
                        )
                            template(v-slot:selection="{ item }")
                                .d-flex.align-center
                                    v-icon.mr-2(v-if="dispositionDisplayColor(item)" small :color="dispositionDisplayColor(item)") mdi-circle
                                    span {{ item.disposition_description }}
                            template(v-slot:item="{ item }")
                                v-tooltip(top max-width="320" :disabled="!dispositionTooltipText(item)")
                                    template(v-slot:activator="{ on, attrs }")
                                        .d-flex.align-center(v-bind="attrs" v-on="on" style="width: 100%;")
                                            v-list-item-icon.mr-2(v-if="dispositionDisplayColor(item)" style="min-width: 24px;")
                                                v-icon(small :color="dispositionDisplayColor(item)") mdi-circle
                                            v-list-item-content
                                                v-list-item-title {{ item.disposition_description }}
                                    span {{ dispositionTooltipText(item) }}

                        v-textarea(
                            v-model="communicationDisposition.notes"
                            label='Notes'
                            rows="1"
                            auto-grow
                            clearable
                            counter
                            outlined
                            dense
                            prepend-inner-icon="mdi-text"
                        )

                        div(v-if="renderAppointmentForm")
                            v-divider.divider-spacing
                            .text-subtitle-2.subtitle-2-padding.text-center
                                | Schedule Appointment
                            
                            template(v-if="tekionActionsEnabled")
                                v-switch(
                                    v-model="pushAppointmentToTekion"
                                    label="Push appointment to Tekion"
                                    color="primary"
                                    :value="true"
                                )

                                v-alert(v-if="pushAppointmentToTekion" type="warning" dense border="left")
                                    | Please create the appointment in the Tekion integrations tab, a disposition will be generated automatically upon creation. 
                            
                            AppointmentForm(
                                :style="{ display: !tekionActionsEnabled || !pushAppointmentToTekion ? 'block' : 'none' }"
                                :appointment-scheduling-hour="currentAppointmentSchedulingHour"
                                :autobuy-communication-disposition="autobuyCommunicationDisposition"
                                :customer="currentCampaignCustomer"
                                :on-appointment-change="onAppointmentChange"
                                :set-appointment-is-unique-if-required="setAppointmentIsUniqueIfRequired"
                                :show-vehicles-dropdown="isSchedulingAppointment && !isReschedulingAppointment"
                                :time-zone-id="customerTimeZoneId"
                                :integration-appointment-details="integrationAppointmentDetails"
                                :use-on-change="true"
                                :valid-customer="validCampaignCustomerActive"
                            )

                            v-divider.divider-spacing

                        div(v-else-if="renderAppointmentRescheduleForm")
                            v-divider.divider-spacing
                            .text-subtitle-2.subtitle-2-padding.text-center
                                | Reschedule Appointment

                            AppointmentRescheduleForm(
                                :on-appointment-change="onAppointmentChange"
                                :appointment-scheduling-hour="currentAppointmentSchedulingHour"
                                :customer="currentCampaignCustomer"
                                :set-appointment-is-unique-if-required="setAppointmentIsUniqueIfRequired"
                                :time-zone-id="customerTimeZoneId"
                                :integration-appointment-details="integrationAppointmentDetails"
                                :upcoming-appointments="rescheduleableAppointments"
                                :valid-customer="validCampaignCustomerActive"
                            )

                            v-divider.divider-spacing

                        div(v-else-if="renderAppointmentCanceledForm")
                            v-divider.divider-spacing
                            .text-subtitle-2.subtitle-2-padding.text-center
                                | Cancel Appointment

                            AppointmentCancelForm(
                                :on-appointment-change="onAppointmentChange"
                                :integration-appointment-details="integrationAppointmentDetails"
                                :upcoming-appointments="upcomingAppointments"
                                :valid-customer="validCampaignCustomerActive"
                            )

                            v-divider.divider-spacing

                        div(v-if="renderScheduledCommunicationForm")
                            v-divider.divider-spacing
                            .text-subtitle-2.subtitle-2-padding.text-center
                                | Schedule next communication

                            ScheduledCommunicationForm(
                                :campaign-id="campaignID"
                                :communication-manager="communicationManager"
                                :default-communication-type="communicationType"
                                :hide-communication-type-select="true"
                                :on-scheduled-communication-change="onScheduledCommunicationChange"
                                :time-zone-id="customerTimeZoneId"
                                :use-on-change="true"
                                :valid-customer="validCampaignCustomerActive"
                            )

                            v-divider.divider-spacing

                        div(v-if="renderDispositionActions")
                            v-divider(v-if="noOtherFormsVisible").divider-spacing
                            .text-subtitle-2.subtitle-2-padding.text-center
                                | Disposition Actions

                            DispositionActionsForm(
                                :campaign-dispositions="campaignDispositions"
                                :campaign-id="campaignID"
                                :current-campaign-disposition="selectedCampaignDisposition"
                                :current-campaign-customer="currentCampaignCustomer"
                                :disposition-actions="selectedCampaignDisposition.disposition_actions"
                                :valid-customer="validCampaignCustomerActive"
                                :valid-disposition-actions="renderDispositionActions"
                                @disposition-action-values="onDispositionActionValues"
                            )

                            v-divider.divider-spacing

                        .text-right
                            v-btn.mr-4.mb-1(
                                @click='resetForm'
                                :x-small="renderPhoneActionButtons && selectedDispositionHasSmsMessageFollowUp"
                                :small="renderPhoneActionButtons && !selectedDispositionHasSmsMessageFollowUp"
                            )
                                | Reset

                            v-btn.mr-4.mb-1(
                                v-if="renderCreateButton"
                                color='success'
                                @click='createCommunicationDisposition()'
                                :disabled="!isOkayToCreateCommunicationDisposition"
                                :x-small="selectedDispositionHasSmsMessageFollowUp"
                                :small="renderPhoneActionButtons && !selectedDispositionHasSmsMessageFollowUp"
                            )
                                | Save

                            v-btn.mr-4.mb-1(
                                v-if="renderAddDispositionButton"
                                color='primary'
                                @click='createCommunicationDisposition()'
                                :disabled="!isOkayToCreateCommunicationDisposition"
                                :small="renderPhoneActionButtons"
                            )
                                v-icon(small) mdi-plus-thick
                                | Add Disposition
                            br

                            template(v-if="renderPhoneActionButtons")
                                v-btn.mr-4(
                                    v-if="renderSaveStopButton"
                                    color='error'
                                    :x-small="selectedDispositionHasSmsMessageFollowUp"
                                    :small="!selectedDispositionHasSmsMessageFollowUp"
                                    @click="startSaveAndNext(saveAndStopAction);"
                                    :disabled="!isOkayToSaveAndNext || isLiveDashInboundCall"
                                )
                                    div(v-if="selectedDispositionHasSmsMessageFollowUp")
                                        | Save & Send SMS Follow Up
                                        v-icon(small) mdi-arrow-right-thick
                                        | Stop
                                    div(v-else)
                                        | Save
                                        v-icon(small) mdi-arrow-right-thick
                                        | Stop

                                v-btn.mr-4(
                                    v-if="renderSaveContinueButton"
                                    color='success'
                                    :x-small="selectedDispositionHasSmsMessageFollowUp"
                                    :small="!selectedDispositionHasSmsMessageFollowUp"
                                    @click="startSaveAndNext('continue');"
                                    :disabled="!isOkayToSaveAndNext"
                                )
                                    div(v-if="selectedDispositionHasSmsMessageFollowUp")
                                        | Save & Send SMS Follow Up
                                        v-icon(small) mdi-arrow-right-thick
                                        | Survey
                                    div(v-else)
                                        | Save
                                        v-icon(small) mdi-arrow-right-thick
                                        | Survey

                                v-btn.mr-4(
                                    v-else
                                    color='success'
                                    :x-small="selectedDispositionHasSmsMessageFollowUp"
                                    :small="!selectedDispositionHasSmsMessageFollowUp"
                                    @click="startSaveAndNext('continue_and_start');"
                                    :disabled="!isOkayToSaveAndNext || isLiveDashInboundCall"
                                )
                                    div(v-if="selectedDispositionHasSmsMessageFollowUp")
                                        | Save & Send SMS Follow Up
                                        v-icon(small) mdi-arrow-right-thick
                                        | Dial Next
                                    div(v-else)
                                        | Save
                                        v-icon(small) mdi-arrow-right-thick
                                        | Dial Next

                                .text-caption.text--secondary.mt-2(v-if="saveDisabledReason")
                                    | {{ saveDisabledReason }}

        v-divider.divider-spacing

        v-container.mx-auto
            .text-subtitle-2.subtitle-2-padding.text-center
                | Previous Dispositions

            CommunicationDispositionDetails(
                v-if="validCommunicationDispositions"
                v-for='communicationDisposition in communicationDispositions'
                :key='communicationDisposition.communication_disposition_id'
                :communication-disposition="communicationDisposition"
                :show-campaign="false"
            )

            v-alert(outlined type='warning' dense border='left' style="margin-top: 16px;" v-if="!validCommunicationDispositions && !isLoadingCommunicationDispositions")
                | No dispositions submitted for this enrollment

            .text-center(v-if="isLoadingCommunicationDispositions")
                v-progress-circular(
                    :size='100'
                    :width='10'
                    color='var(--volie-blue)'
                    indeterminate
                    style="margin-top: 100px;"
                )

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    // Components
    import AppointmentCancelForm from '@/components/appointments/cancel.vue';
    import AppointmentForm from '@/components/appointments/form.vue';
    import AppointmentRescheduleForm from '@/components/appointments/reschedule_form.vue';
    import CommunicationDispositionDetails from '@/components/communication_dispositions/communication_disposition_details.vue';
    import ScheduledCommunicationForm from '@/components/scheduled_communications/form.vue';
    import DispositionActionsForm from '@/components/communication_center/shared/tabs/disposition_actions/disposition_actions_form.vue';
    import DispositionSelectChip from '@/components/communication_center/shared/tabs/disposition_select_chip.vue';


    // Data
    import {
        CreateCommunicationDisposition,
        GetAppointmentHistory,
        GetAppointmentSchedulingHours,
        GetCampaignDispositionGroups,
        GetCampaignDispositions,
        GetCommunicationDispositions,
        GetMostRecentlyUsedAndMostUsedDispositionsForAccountUser,
    } from "@/data";

    // Helpers
    import { dispositionDisplayColor, dispositionTooltipText } from "@/helpers/dispositions";
    import { jsDayToFriendly } from "@/helpers/general";

    export default Vue.extend({
        data() {
            return {
                appointment: null,
                appointmentSchedulingHour: null,
                bus: VolieState.websocketClient().eventBus(),
                campaignDispositionMap: {},
                campaignDispositionGroups: [],
                currentSelectedCampaignDispositionGroupId: 0,
                dispositionActionValues: [],
                communicationDisposition: {},
                communicationDispositions: [],
                isCreatingCommunicationDisposition: false,
                isLoading: true, // default to true so the tab shows the loader from the start rather than the error alert before initial search
                isLoadingCommunicationDispositions: false,
                isLoadingCampaignDispositionGroups: false,
                integrationAppointmentDispositionTimeoutId: null,
                loadedAppointmentSchedulingHours: false,
                pastAppointments: [],
                pushAppointmentToTekion: false,
                rescheduleableAppointments: [],
                scheduledCommunication: {
                    assignment_id: null,
                    assignment_type: null,
                    communication_type: null,
                    notes: null,
                    preference_id: null,
                    preference_type: null,
                    scheduled_time_date: null,
                    scheduled_time_time: null,
                    time_zone_id: null,
                },
                selectedCampaignDisposition: null,
                upcomingAppointments: [],
                queuedDispositionActionCampaignDispositionIds: [],
                currentDispositionFromPreviousAction: false,
                isAutomaticallySettingDispositionFromAction: false,
                previousActionDispositionId: null,
            }
        },
        methods: {
            buildRescheduleableAppointments() {

                // Reset
                this.rescheduleableAppointments = [];

                // Ensure past and/or upcoming are present
                if (!this.validPastAppointments && !this.validUpcomingAppointments) {
                    return;
                }

                // Set all upcoming appointments
                this.rescheduleableAppointments = (this.upcomingAppointments || []);

                // If account has appt no show reschedule window days > 0, see if any fall in the window
                if (this.accountAppointmentNoShowRescheduleWindowDays === 0 || !this.validPastAppointments) {
                    return;
                }

                // Loop over past appointments and see if any are in the window
                for (let i = 0; i < this.pastAppointments.length; i++) {

                    // Init
                    const appointment = this.pastAppointments[i];
                    if (!(appointment?.appointment_id > 0)) {
                        continue;
                    }

                    // Check if inside window
                    if (!appointment.is_inside_no_show_reschedule_window) {
                        continue;
                    }

                    // Append to slice
                    this.rescheduleableAppointments.push(appointment);
                }
            },
            clearIntegrationAppointmentDispositionTimeout() {
                if (this.integrationAppointmentDispositionTimeoutId !== null) {
                    clearTimeout(this.integrationAppointmentDispositionTimeoutId);
                    this.integrationAppointmentDispositionTimeoutId = null;
                }
            },
            createAgentForSavedDisposition(communicationDisposition) {
                if (!(communicationDisposition?.communication_disposition_id > 0) || !(this.communicationType?.length > 0)) {
                    return;
                }

                const options = {
                    campaign_customer_id: communicationDisposition.campaign_customer_id,
                    campaign_id: communicationDisposition.campaign_id,
                    immediately_move_to_status: null,
                    noticeable_id: communicationDisposition.communication_disposition_id,
                    noticeable_type: "communication_disposition",
                    organization_id: communicationDisposition.organization_id,
                    status_name: null,
                }

                // Switch over communication type
                switch (this.communicationType) {
                    case "Email":
                        options.status_name = "Email - Saved Disposition";
                        break;

                    case "Phone":
                        options.status_name = "Finished CampaignCustomer";
                        break;

                    case "SMS Message":
                        options.status_name = "SMS Message - Saved Disposition";
                        break;

                    default: // non-supported communication type
                        return;
                }

                this.createAgent(options);
            },
            createCommunicationDisposition() {
                if (!this.isOkayToCreateCommunicationDisposition && !this.isOkayToSurveySavedDisposition) {
                    // Reset to null so the form is free to be used again even if this fails
                    if (this.integrationAppointmentDetails) {
                        this.setIntegrationAppointmentDetails(null, true);
                    }
                    // Aborting here is terminal, so release the parent's overlay or the agent is stuck behind it
                    if (this.initiateCreateCommunicationDisposition === true) {
                        this.finishSaveAndNextOverlay?.();
                    }
                    return;
                }

                if (this.isCreatingCommunicationDisposition) {
                    return;
                }

                const surveySelectedDisposition = this.campaignDispositionToSurvey === this.selectedCampaignDisposition;
                // If there is not a selected disposition, use the prioritized saved disposition for the survey attempt to avoid duplicate saving
                if (!this.selectedCampaignDisposition && this.campaignDispositionToSurvey) {
                    this.createAgentForSavedDisposition(this.campaignDispositionToSurvey);
                    this.createSurveyAttempt(this.campaignDispositionToSurvey.communication_disposition_id);

                    // reset saved communication dispositions
                    this.resetSavedCommunicationDispositions();
                    this.resetCampaignDispositionToSurvey();

                    // Reset to null so the form is free to be used again even if this fails
                    if (this.integrationAppointmentDetails) {
                        this.setIntegrationAppointmentDetails(null, true);
                    }

                    this.isLoading = false;
                    return;
                }

                // If cc active is missing, agent MUST have reception mode enabled in order to move on without a customer
                if (!(this.currentCampaignCustomer?.campaign_customer_active_id > 0)) {

                    // If the agent doesn't have reception mode enabled, need to issue error and abort
                    if (!this.receptionModeEnabled) {
                        this.showSnackbar("error", "You must find or create a customer first");

                        // Reset to null so the form is free to be used again even if this fails
                        if (this.integrationAppointmentDetails) {
                            this.setIntegrationAppointmentDetails(null, true);
                        }
                        // Aborting here is terminal, so release the parent's overlay or the agent is stuck behind it
                        if (this.initiateCreateCommunicationDisposition === true) {
                            this.finishSaveAndNextOverlay?.();
                        }
                        return;
                    }
                }

                const options = {
                    appointment: this.appointment,
                    autobuy: this.autobuyCommunicationDisposition,
                    communication_disposition: {
                        campaign_customer_active_id: (this.currentCampaignCustomer.campaign_customer_active_id || 0),
                        campaign_customer_id: (this.currentCampaignCustomer.campaign_customer_id || 0),
                        campaign_disposition_id: this.communicationDisposition.campaign_disposition_id,
                        communication_channel: null,
                        communication_id: null,
                        notes: this.communicationDisposition.notes,
                        voice_mail_recording_id: (this.voiceMailRecording?.voice_mail_recording_id || 0),
                    },
                    saved_place_scheduled_communication_id: (this.pendingSavedPlaceCall?.scheduled_communication_id || 0),
                    scheduled_communication: {
                        assignment_id: (this.scheduledCommunication?.assignment_id || 0),
                        assignment_type: this.scheduledCommunication?.assignment_type,
                        communication_type: this.scheduledCommunication?.communication_type,
                        notes: this.scheduledCommunication?.notes,
                        preference_id: (this.scheduledCommunication?.preference_id || 0),
                        preference_type: this.scheduledCommunication?.preference_type,
                        scheduled_time_date: this.scheduledCommunication?.scheduled_time_date,
                        scheduled_time_time: this.scheduledCommunication?.scheduled_time_time,
                        time_zone_id: this.scheduledCommunication?.time_zone_id,
                    },
                    integration: this.integrationAppointmentDetails,
                    disposition_action_values: this.dispositionActionValues,
                }

                // set vmr id on communication disposition if call getting dispositioned was transferred from vmr 
                // so that when create the survey attempt we complete the vmr. 
                if (this.callTransfer?.voice_mail_recording_id > 0) {
                    options.communication_disposition.voice_mail_recording_id = this.callTransfer.voice_mail_recording_id;
                }

                // Set communication channel if applicable
                if (this.communicationType?.length > 0) {

                    // Switch over type
                    switch(this.communicationType) {
                    case "Phone":
                        options.communication_disposition.communication_channel = "call";
                        options.communication_disposition.communication_id = this.callId;
                        break;

                    }
                }

                this.isCreatingCommunicationDisposition = true;
                this.isLoading = true;
                CreateCommunicationDisposition(options).then((response) => {
                    if (response?.Data?.communication_disposition?.communication_disposition_id > 0) {
                        if (this.communicationType === "Phone" && this.isValidToMultipleDisposition) {
                            const dispositionWithSalesOpportunity = {
                                ...response.Data.communication_disposition,
                                denotes_sales_opportunity: this.selectedCampaignDisposition?.denotes_sales_opportunity
                            };
                            this.addSavedCommunicationDisposition(dispositionWithSalesOpportunity);
                        }

                        // Only create an agent for phone communications when the survey attempt is made below
                        if (this.communicationType !== "Phone") {
                            this.createAgentForSavedDisposition(response.Data.communication_disposition);
                        }

                        // If we have selected disposition action dispositions, queue them
                        if (this.selectedDispositionActionCampaignDispositionIds?.length > 0) {
                            this.queuedDispositionActionCampaignDispositionIds.push(...this.selectedDispositionActionCampaignDispositionIds);
                        }

                        // If we canceled the appointment via disposition and not via integration, reinit get in integration tab so that the appointments reflect accurately
                        if (this.tekionActionsEnabled && this.selectedCampaignDisposition?.denotes_appointment_cancel && !(this.integrationAppointmentDetails?.appointment_id > 0)) {
                            this.reinitIntegrationCustomers();
                        }

                        this.resetForm();
                        this.initNewCommunicationDisposition();

                        this.showSnackbar("green", "Successfully saved disposition");

                        // Set on current
                        if (this.setChangeOnCurrentCampaignCustomer !== null && this.setChangeOnCurrentCampaignCustomer !== undefined && response?.Data?.total_communication_dispositions > 0) {
                            this.setChangeOnCurrentCampaignCustomer("total_communication_dispositions", response.Data.total_communication_dispositions);
                        }

                        // In case of opt in out via disposition, set subscription changes on communication manager
                        if (this.setSubscriptionChangesOnCommunicationManager !== null && this.setSubscriptionChangesOnCommunicationManager !== undefined) {
                            this.setSubscriptionChangesOnCommunicationManager(response);
                        }

                        this.onNewCommunicationDisposition(response);

                        // If the create was initiated from the parent, need to also create survey attempt
                        if (this.initiateCreateCommunicationDisposition === true) {
                            if (this.campaignDispositionToSurvey && !surveySelectedDisposition) {
                                this.createAgentForSavedDisposition(this.campaignDispositionToSurvey);
                                this.createSurveyAttempt(this.campaignDispositionToSurvey.communication_disposition_id);
                            } else {
                                this.createAgentForSavedDisposition(response?.Data?.communication_disposition);
                                this.createSurveyAttempt(response?.Data?.communication_disposition?.communication_disposition_id);
                            }

                            // reset saved communication dispositions
                            if (this.isValidToMultipleDisposition) {
                                this.resetSavedCommunicationDispositions();
                                this.resetCampaignDispositionToSurvey();
                            }
                        }

                    } else {
                        // Save failed: surface an error so the agent isn't left staring at a spinner
                        // or a Complete button that never enables.
                        const errorMessage = response?.Error?.length > 0
                            ? response.Error
                            : "Unable to save disposition. Please try again.";
                        this.showSnackbar("error", errorMessage);
                        if (this.initiateCreateCommunicationDisposition === true) {
                            this.finishSaveAndNextOverlay?.();
                        }
                    }
                    // If we created a disposition with an integration appointment, reset to null so the form is free to be used again (even if backend call fails)
                    if (this.integrationAppointmentDetails) {
                        this.setIntegrationAppointmentDetails(null, true);
                    }
                    this.isLoading = false;
                }).catch((err) => {
                    console.error("create communication disposition failed", err);
                    this.showSnackbar("error", "Unable to save disposition. Please try again.");
                    if (this.initiateCreateCommunicationDisposition === true) {
                        this.finishSaveAndNextOverlay?.();
                    }
                    this.isLoading = false;
                }).finally(() => {
                    this.isCreatingCommunicationDisposition = false;
                });
            },
            dispositionDisplayColor,
            dispositionTooltipText,
            findAndSelectCancelAppointmentCampaignDisposition() {
                // Score each campaign disposition by how well it matches appointment scheduling criteria
                let scoredMatches = [];
                
                for (const campaignDisposition of this.campaignDispositions) {
                    let score = 0;
                    const dispositionDescription = campaignDisposition.disposition_description?.toLowerCase() || '';
                    
                    // Must denote appointment cancel to be considered
                    if (!campaignDisposition?.denotes_appointment_cancel) {
                        continue;
                    }
                    
                    // High priority keywords for appointment cancelling
                    const cancelKeywords = ['cancel', 'appointment', 'appt'];
                    const hasCancelKeywords = cancelKeywords.some(keyword => 
                        dispositionDescription.includes(keyword)
                    );
                    
                    if (hasCancelKeywords) {
                        score += 100;
                    }
                    
                    scoredMatches.push({ campaignDisposition, score });
                }
                
                // Sort by score (highest first)
                scoredMatches.sort((a, b) => b.score - a.score);
                
                // Select the best match
                const bestMatch = scoredMatches[0];
                if (bestMatch && bestMatch.score > 0) {
                    this.communicationDisposition.campaign_disposition_id = bestMatch.campaignDisposition.campaign_disposition_id;
                    this.handleCampaignDispositionSelectChange();
                }
            },
            findAndSelectScheduleAppointmentCampaignDisposition() {
                // Score each campaign disposition by how well it matches appointment scheduling criteria
                let scoredMatches = [];
                
                for (const campaignDisposition of this.campaignDispositions) {
                    let score = 0;
                    const dispositionDescription = campaignDisposition.disposition_description?.toLowerCase() || '';
                    
                    // Must denote appointment to be considered
                    if (!campaignDisposition?.denotes_appointment) {
                        continue;
                    }
                    
                    // High priority keywords for appointment scheduling
                    const schedulingKeywords = ['set', 'schedule', 'appointment'];
                    const hasSchedulingKeyword = schedulingKeywords.some(keyword => 
                        dispositionDescription.includes(keyword)
                    );
                    
                    if (hasSchedulingKeyword) {
                        score += 100;
                    }

                    // Subtract points for cancel or reschedule
                    const cancelOrRescheduleKeywords = ['cancel', 'reschedule'];
                    const hasCancelOrRescheduleKeyword = cancelOrRescheduleKeywords.some(keyword => 
                        dispositionDescription.includes(keyword)
                    );
                    
                    if (hasCancelOrRescheduleKeyword) {
                        score -= 100;
                    }
                    
                    // Additional keywords that suggest appointment creation
                    const appointmentKeywords = ['create', 'new', 'make', 'arrange', 'book'];
                    const hasAppointmentKeyword = appointmentKeywords.some(keyword => 
                        dispositionDescription.includes(keyword)
                    );
                    
                    if (hasAppointmentKeyword) {
                        score += 60;
                    }
                    
                    scoredMatches.push({ campaignDisposition, score });
                }
                
                // Sort by score (highest first)
                scoredMatches.sort((a, b) => b.score - a.score);
                
                // Select the best match
                const bestMatch = scoredMatches[0];
                if (bestMatch && bestMatch.score > 0) {
                    this.communicationDisposition.campaign_disposition_id = bestMatch.campaignDisposition.campaign_disposition_id;
                    this.handleCampaignDispositionSelectChange();
                }
            },
            getAppointmentSchedulingHours() {

                // Ensure not already run
                if (this.loadedAppointmentSchedulingHours) {
                    return;
                }

                // Verify valid communication disposition
                if (!(this.selectedCampaignDisposition?.campaign_disposition_id > 0)) {
                    return;
                }

                // Ensure new appt or reschedule
                if (!this.renderAppointmentForm && !this.renderAppointmentRescheduleForm) {
                    return;
                }

                // Load them
                const options = {
                    ownable_id: (this.currentCampaignCustomer?.campaign_id || 0),
                    ownable_type: "campaign",
                }

                GetAppointmentSchedulingHours(options).then((response) => {
                    if (response?.Data?.appointment_scheduling_hours?.length === 1) {
                        this.appointmentSchedulingHour = response.Data.appointment_scheduling_hours[0];
                    }

                    // Set to true so no matter what we don't run again
                    // todo - double check inbound call with campaign update logic
                    this.loadedAppointmentSchedulingHours = true;
                });
            },
            getCampaignDispositionGroups() {
                if (!(this.currentCampaignCustomer?.campaign_id > 0) || this.campaignDispositionMode !== "advanced") {
                    return;
                }

                const options = {
                    campaign_id: this.currentCampaignCustomer.campaign_id,
                }

                this.isLoadingCampaignDispositionGroups = true;
                GetCampaignDispositionGroups(options).then((response) => {
                    this.isLoadingCampaignDispositionGroups = false;

                    if (response?.Data?.campaign_disposition_groups?.length > 0) {
                        this.campaignDispositionGroups = response.Data.campaign_disposition_groups;

                        this.currentSelectedCampaignDispositionGroupId = this.campaignDispositionGroups[0]?.campaign_disposition_group_id || 0;
                    } else {
                        this.showSnackbar("error", "No campaign disposition groups found");
                    }
                });
            },
            getCampaignDispositions(campaignDispositionGroupId = 0) {
                if (!(this.currentCampaignCustomer?.campaign_id > 0)) {
                    return;
                }

                if (this.campaignDispositionMap[campaignDispositionGroupId] != null) {
                    return;
                }

                const newObject = {
                    dispositions: [], 
                    isLoading: true, 
                    mostRecentlyUsedDispositions: [],
                    mostUsedDispositions: [],
                }

                Vue.set(this.campaignDispositionMap, campaignDispositionGroupId, newObject);

                const options = {
                    campaign_customer_active_id: (this.currentCampaignCustomer.campaign_customer_active_id || 0),
                    campaign_disposition_group_id: campaignDispositionGroupId,
                    campaign_id: this.currentCampaignCustomer.campaign_id,
                    sort_by_disposition_order: true,
                }

                GetCampaignDispositions(options).then((response) => {
                    if (response?.Data?.campaign_dispositions?.length > 0) {
                        this.campaignDispositionMap[campaignDispositionGroupId].dispositions = response.Data.campaign_dispositions;
                        
                        if (this.communicationType === "Phone" && this.isValidToMultipleDisposition) {
                            this.setCampaignDispositions(this.campaignDispositionMap[campaignDispositionGroupId].dispositions);
                        }
                    }
                    
                    this.isLoading = false;
                    this.campaignDispositionMap[campaignDispositionGroupId].isLoading = false;
                    this.getMostRecentlyUsedAndMostUsedDispositionsForAccountUser(campaignDispositionGroupId); // call this after the campaign dispositions are loaded so we can filter them
                });
            },
            getMostRecentlyUsedAndMostUsedDispositionsForAccountUser(campaignDispositionGroupId = 0) {
                if (!(this.currentCampaignCustomer?.campaign_id > 0) || !(this.currentUser?.account_user?.account_user_id > 0) || !(this.currentUser.account.disposition_suggestions_enabled === true)) {
                    return;
                }

                const options = {
                    account_user_id: this.currentUser?.account_user?.account_user_id,
                    campaign_disposition_group_id: campaignDispositionGroupId,
                    campaign_id: this.currentCampaignCustomer?.campaign_id,
                    limit: 5,
                }

                const cached = this.campaignDispositionMap[campaignDispositionGroupId];

                GetMostRecentlyUsedAndMostUsedDispositionsForAccountUser(options).then((response) => {
                    if (response?.Data?.most_recently_used_disposition_ids?.length > 0) {
                        // Create an array of dispositions in the same order as the IDs
                        cached.mostRecentlyUsedDispositions = response.Data.most_recently_used_disposition_ids
                            .map(id => this.campaignDispositionMap[campaignDispositionGroupId]?.dispositions?.find(d => d.disposition_id === id))
                            .filter(Boolean);
                    }

                    if (response?.Data?.most_used_disposition_ids?.length > 0) {
                        // Create an array of dispositions in the same order as the IDs
                        cached.mostUsedDispositions = response.Data.most_used_disposition_ids
                            .map(id => this.campaignDispositionMap[campaignDispositionGroupId]?.dispositions?.find(d => d.disposition_id === id))
                            .filter(Boolean);
                    }

                    this.handleMostUsedDispositionSelection();
                });
            },
            getCommunicationDispositions() {
                if (!(this.currentCampaignCustomer?.customer_id > 0 && this.currentCampaignCustomer?.campaign_customer_id > 0)) {
                    return;
                }

                const options = {
                    campaign_customer_id: this.currentCampaignCustomer.campaign_customer_id,
                    customer_id:          this.currentCampaignCustomer.customer_id,
                }

                this.isLoading = true;
                GetCommunicationDispositions(options).then((response) => {
                    if (response?.Data?.communication_dispositions?.length > 0) {
                        this.communicationDispositions = response.Data.communication_dispositions;
                    }

                    this.isLoading = false;
                });
            },
            getUpcomingAppointments() {
                if (!(this.currentCampaignCustomer?.customer_id > 0)) {
                    return;
                }

                const options = {
                    customer_id: this.currentCampaignCustomer.customer_id,
                }

                this.isLoading = true;
                GetAppointmentHistory(options).then((response) => {
                    if (response?.Data?.past_appointments?.length > 0 || response?.Data?.upcoming_appointments?.length > 0) {
                        // Set
                        this.pastAppointments = response.Data.past_appointments;
                        this.upcomingAppointments = response.Data.upcoming_appointments;

                        // Setup upcoming and missed slice
                        this.buildRescheduleableAppointments();
                    }
                    this.isLoading = false;
                });
            },
            handleCampaignDispositionSelectChange() {

                // Reset objects
                this.appointment = null;
                // this.scheduledCommunication = null;
                if (!this.isAutomaticallySettingDispositionFromAction && this.currentDispositionFromPreviousAction) {
                    this.currentDispositionFromPreviousAction = false;
                }

                //Reset alert message if you reselect the dispostion that was triggered form the previous dispositions action 
                if (this.previousActionDispositionId === this.communicationDisposition?.campaign_disposition_id) {
                    this.currentDispositionFromPreviousAction = true;
                }

                if (this.communicationDisposition?.campaign_disposition_id > 0) {
                    this.selectCampaignDisposition();
                }
            },
            handleDispositionBtnSelect(disposition) {
                // Set the campaign disposition id while maintaining reactivity
                this.$set(this.communicationDisposition, "campaign_disposition_id", disposition.campaign_disposition_id);
                this.handleCampaignDispositionSelectChange();
            },
            async init() {
                this.isLoading = true;

                switch (this.campaignDispositionMode) {
                    case 'advanced':
                        this.getCampaignDispositionGroups();
                        break;
                    default:
                        this.getCampaignDispositions();
                }
            },
            initNewCommunicationDisposition() {
                this.currentDispositionFromPreviousAction = false;

                this.communicationDisposition = {
                    campaign_disposition_id: null,
                    notes: this.parentDispositionNotes?.length > 0 && !(this.communicationType === "Phone") ? this.parentDispositionNotes : null,
                };

                // If we have queued dispositions, set the first one
                if (this.queuedDispositionActionCampaignDispositionIds?.length > 0) {
                    this.isAutomaticallySettingDispositionFromAction = true; //This is only to set the message of linked dispositions
                    this.currentDispositionFromPreviousAction = true;
                    this.$set(this.communicationDisposition, 'campaign_disposition_id', this.queuedDispositionActionCampaignDispositionIds[0]);
                    this.previousActionDispositionId = this.queuedDispositionActionCampaignDispositionIds[0];
                    this.queuedDispositionActionCampaignDispositionIds.shift(); 
                    this.handleCampaignDispositionSelectChange();
                    this.isAutomaticallySettingDispositionFromAction = false; // Allow manual reset again, which will clear message

                }
            },
            onNewCommunicationDisposition(response) {

                // Verify legit communication disposition
                const data = response?.Data;
                const communicationDisposition = data?.communication_disposition;
                if (!(communicationDisposition?.communication_disposition_id > 0) || !(communicationDisposition?.campaign_customer_active_id > 0) || !(communicationDisposition?.account_id > 0)) {
                    return;
                }

                // Verify the campaign customer is the same and if so, set total
                if (this.setChangeOnCurrentCampaignCustomer !== null && this.setChangeOnCurrentCampaignCustomer !== undefined && this.currentCampaignCustomer?.campaign_customer_active_id === communicationDisposition.campaign_customer_active_id) {
                    this.setChangeOnCurrentCampaignCustomer("total_communication_dispositions", (data?.total_communication_dispositions || 0));

                    if (communicationDisposition?.communication_disposition_id > 0) {

                        // Verify new data to current screen
                        if (this.communicationDispositions?.length > 0) {
                            const existingNewCommunicationDisposition = this.communicationDispositions.find(x => x.communication_disposition_id === communicationDisposition.communication_disposition_id);

                            // Return if new communication disposition already in array
                            if (existingNewCommunicationDisposition?.communication_disposition_id > 0) {
                                return;
                            }
                        }

                        // Insert new communication disposition to front of communicationDispositions array
                        this.communicationDispositions.unshift(communicationDisposition);
                    }
                }
            },
            onAppointmentChange(appointment) {

                // Verify
                if (!appointment) {
                    return;
                }

                // Set appointment
                this.appointment = appointment;
            },
            onScheduledCommunicationChange(scheduledCommunication) {

                // Verify
                if (!scheduledCommunication) {
                    return;
                }

                // Set details
                this.scheduledCommunication.assignment_id = scheduledCommunication.assignment_id;
                this.scheduledCommunication.assignment_type = scheduledCommunication.assignment_type;
                this.scheduledCommunication.communication_type = scheduledCommunication.communication_type;
                this.scheduledCommunication.notes = scheduledCommunication.notes;
                this.scheduledCommunication.preference_id = scheduledCommunication.preference_id;
                this.scheduledCommunication.preference_type = scheduledCommunication.preference_type;
                this.scheduledCommunication.scheduled_time_date = scheduledCommunication.scheduled_time_date;
                this.scheduledCommunication.scheduled_time_time = scheduledCommunication.scheduled_time_time;
                this.scheduledCommunication.time_zone_id = scheduledCommunication.time_zone_id;
            },
            resetForm() {
                this.appointment = null;
                this.selectedCampaignDisposition = null;
                this.communicationDisposition = {};
                this.currentDispositionFromPreviousAction = false;
            },
            selectCampaignDisposition() {
                if (!this.validCampaignDispositions || !(this.communicationDisposition?.campaign_disposition_id > 0)) {
                    return;
                }

                for (let i = 0; i < this.campaignDispositions.length; i++) {
                    const campaignDisposition = this.campaignDispositions[i];
                    if (campaignDisposition?.campaign_disposition_id === this.communicationDisposition?.campaign_disposition_id) {
                        this.selectedCampaignDisposition = campaignDisposition;
                        break;
                    }
                }

                // Handle necessary data loads
                if (this.selectedCampaignDisposition?.campaign_disposition_id > 0) {

                    // For appt reschedule or cancel, need to load upcoming appointments
                    if (this.selectedCampaignDisposition.denotes_appointment_reschedule === true || this.selectedCampaignDisposition.denotes_appointment_cancel === true) {
                        this.getUpcomingAppointments();
                    }

                }
            },
            handleMostUsedDispositionSelection() {
                if (this.selectMostUsedDisposition && 
                    (!this.communicationDisposition.campaign_disposition_id || this.communicationDisposition.campaign_disposition_id === 0) && 
                    this.mostUsedDispositions.length > 0 &&
                    this.dispositionAutoSelectEnabled === true) {
                    this.handleDispositionBtnSelect(this.mostUsedDispositions[0]); // auto select the first one
                }
            },
            onDispositionActionValues(values) {
                this.dispositionActionValues = values;
            },
            areAllRequiredDispositionActionsFilled() {
                if (!this.selectedCampaignDisposition?.disposition_actions) {
                    return true;
                }
                
                const requiredActions = this.selectedCampaignDisposition.disposition_actions.filter(action => action.is_required === true);
                
                if (requiredActions.length === 0) {
                    return true;
                }
                
                return requiredActions.every(requiredAction => {
                    return this.dispositionActionValues.some(value => 
                        value.disposition_action_id === requiredAction.disposition_action_id
                    );
                });
            },
        },
        computed: {
            accountAppointmentNoShowRescheduleWindowDays() {
                return this.currentUser?.account?.appointment_no_show_reschedule_window_days || 0;
            },
            accountPhoneSaveNext() {
                return this.currentUser?.account?.phone_save_next;
            },
            accountPhoneSaveStop() {
                return this.currentUser?.account?.phone_save_stop;
            },
            campaignDispositionMode() {
                return this.currentCampaignCustomer?.campaign_disposition_mode || "default";
            },
            campaignDispositions() {
                if (this.campaignDispositionMode !== "advanced") {
                    return this.campaignDispositionMap[0]?.dispositions || [];
                }

                return this.campaignDispositionMap[this.currentSelectedCampaignDispositionGroupId || 0]?.dispositions || [];
            },
            campaignDispositionsDropdownDisabled() {
                if (this.campaignDispositionMode === "advanced") {
                    return !(this.currentSelectedCampaignDispositionGroupId > 0);
                }

                return false;
            },
            campaignID() {
                return this.currentCampaignCustomer?.campaign_id;
            },
            requiresDispositionActions() {
                return this.selectedCampaignDisposition?.disposition_actions?.some(action => action.is_required);
            },
            currentAppointmentSchedulingHour() {

                // Verify
                if (!(this.appointmentSchedulingHour?.days?.length > 0) || !(this.appointment?.appointment_datetime_date?.length > 0)) {
                    return null;
                }

                // Init current time in local
                const localNow = new Date(this.appointment.appointment_datetime_date);

                // Convert to utc so it matches date selected
                const current = new Date(localNow.getTime() + localNow.getTimezoneOffset() * 60000);

                // Loop over and find matching day
                for (let i = 0; i < this.appointmentSchedulingHour.days.length; i++) {

                    // Init day
                    const day = this.appointmentSchedulingHour.days[i];
                    if (day?.day !== jsDayToFriendly(current.getDay())) {
                        continue;
                    }

                    return day;
                }

                return null;
            },
            currentUser() {
                return VolieState.currentUser();
            },
            sortedCampaignDispositionsForDropdown() {
                const list = this.campaignDispositions || [];
                if (list.length === 0) return list;

                // Fallback to campaign disposition order (default behavior) just as a precaution
                const mode = this.currentUser?.account_user?.disposition_sort_order || 'campaign_disposition_order';

                if (mode === 'alphabetical') {
                    return [...list].sort((a, b) => (a.disposition_description || '').localeCompare(b.disposition_description || ''));
                }

                if (mode === 'most_used') {
                    const mostUsed = this.mostUsedDispositions || [];
                    if (mostUsed.length === 0) {
                        return [...list];
                    }

                    const usedIds = new Set(mostUsed.map(d => d.disposition_id));
                    const ordered = [...mostUsed];
                    for (const d of list) {
                        if (!usedIds.has(d.disposition_id)) {
                            ordered.push(d);
                        }
                    }

                    return ordered;
                }

                return list;
            },
            currentUserHasColumnDispositionsView() {
                return this.currentUser?.account_user?.column_dispositions_view === true;
            },
            customerTimeZoneId() {

                // Try and use the customer's time zone
                if (this.currentCampaignCustomer?.customer?.time_zone_id > 0) {
                    return this.currentCampaignCustomer.customer.time_zone_id;
                }

                // Now try to use the organization's time zone
                if (this.currentCampaignCustomer?.organization_time_zone_id > 0) {
                    return this.currentCampaignCustomer?.organization_time_zone_id;
                }

                return -1;
            },
            dispositionAutoSelectEnabled() {
                return this.currentUser?.account?.disposition_auto_select_enabled === true;
            },
            isOkayToCreateCommunicationDisposition() {
                if (this.communicationDisposition?.campaign_disposition_id > 0 && this.communicationDisposition?.campaign_disposition_id === this.selectedCampaignDisposition?.campaign_disposition_id) {

                    // If communication type is "Phone", callID MUST be present if the call has not failed
                    if (this.communicationType === "Phone" && !(this.callId > 0) && !this.callFailed) {
                        return false;
                    }

                    // If disposition requires a new appointment, verify it is present
                    if ((this.renderAppointmentForm || this.renderAppointmentRescheduleForm) && !this.validNewAppointment) {
                        return false;
                    }

                    // Verify for rescheduled appt that the datetime changed
                    if (this.renderAppointmentRescheduleForm && !(this.appointment?.datetime_changed === true)) {
                        return false;
                    }

                    // If disposition requires an existing appointment, verify it is present
                    if (this.renderAppointmentCanceledForm && (!(this.appointment?.appointment_id > 0) && !(this.integrationAppointmentDetails?.appointment_id > 0))) {
                        return false;
                    }

                    // If disposition requires a scheduled communication, verify it is present
                    if (this.renderScheduledCommunicationForm) {
                        // If any required values are null, disable button
                        if (this.scheduledCommunication.scheduled_time_date === null || this.scheduledCommunication.scheduled_time_time === null || this.scheduledCommunication.time_zone_id === null) {
                            return false;
                        }
                    }

                    // If disposition requires disposition actions, verify all required actions are filled out
                    if (this.requiresDispositionActions) {
                        if (!this.areAllRequiredDispositionActionsFilled()) {
                            return false;
                        }
                    }

                    return true;
                }

                return false;
            },
            isValidToMultipleDisposition() {
                // Ensure we have a valid campaign customer and all functions are present for multiple disposition
                if (!this.validCampaignCustomerActive) {
                    return false;
                }

                if (this.addSavedCommunicationDisposition == null || this.addSavedCommunicationDisposition == undefined) {
                    return false;
                }

                if (this.resetCampaignDispositionToSurvey == null || this.resetCampaignDispositionToSurvey == undefined) {
                    return false;
                }

                if (this.resetSavedCommunicationDispositions == null || this.resetSavedCommunicationDispositions == undefined) {
                    return false;
                }

                if (this.setCampaignDispositions == null || this.setCampaignDispositions == undefined) {
                    return false;
                }

                if (this.setIsOkayToSurveySavedDisposition == null || this.setIsOkayToSurveySavedDisposition == undefined) {
                    return false;
                }

                return true;
            },
            isOkayToSaveAndNext() {
                // If we have disposition actions, we need to verify they are all filled out
                if (this.selectedDispositionActionCampaignDispositionIds.length > 0 || this.queuedDispositionActionCampaignDispositionIds.length > 0) {
                    return false;
                }

                // Make sure all pieces for multiple disposition are present - use single disposition logic if not
                if (!this.isValidToMultipleDisposition) {
                    return this.isOkayToCreateCommunicationDisposition;
                }

                // If we are valid to multiple disposition, use that logic instead
                if (!!this.selectedCampaignDisposition) {
                    return this.isOkayToCreateCommunicationDisposition;
                } else {
                    return this.isOkayToSurveySavedDisposition;
                }
            },
            isOkayToSurveySavedDisposition() {
                // Make sure all pieces for multiple disposition are present
                if (!this.isValidToMultipleDisposition) {
                    return false;
                }

                return this.savedCommunicationDispositions.length > 0;
            },
            mostRecentlyUsedDispositions() {
                return this.campaignDispositionMap[this.currentSelectedCampaignDispositionGroupId || 0]?.mostRecentlyUsedDispositions || [];
            },
            mostUsedDispositions() {
                return this.campaignDispositionMap[this.currentSelectedCampaignDispositionGroupId || 0]?.mostUsedDispositions || [];
            },
            noOtherFormsVisible() {
                return !this.renderAppointmentForm && !this.renderAppointmentRescheduleForm && !this.renderAppointmentCanceledForm && !this.renderScheduledCommunicationForm;
            },
            isReschedulingAppointment() {
                return this.renderAppointmentRescheduleForm === true;
            },
            isSchedulingAppointment() {
                return this.renderAppointmentForm === true;
            },
            receptionModeEnabled() {
                return this.currentUser?.account_user?.reception_mode_enabled === true || this.isSavedPlaceCall;
            },
            renderAppointmentForm() {
                return this.selectedCampaignDisposition?.campaign_disposition_id > 0 && this.selectedCampaignDisposition?.denotes_appointment === true;
            },
            renderCampaignDispositionError() {
                return (!this.validCampaignDispositions && !this.isLoading && this.campaignDispositionMode !== "advanced");
            },
            renderAddDispositionButton() {
                return this.communicationType === "Phone" && this.isValidToMultipleDisposition;
            },
            renderCreateButton() {
                return this.communicationType !== "Phone";
            },
            renderDispositionActions() {
                return this.selectedCampaignDisposition?.campaign_disposition_id > 0 && this.selectedCampaignDisposition?.disposition_actions?.length > 0;
            },
            renderPhoneActionButtons() {
                return this.communicationType === "Phone" && (this.validCampaignCustomerActive || this.receptionModeEnabled);
            },
            renderSaveContinueButton() {
                return this.renderPhoneActionButtons && (this.isManualMode || this.isLiveDashInboundCall || this.accountPhoneSaveNext === "continue" || (this.validVoiceMailRecording && !this.missedCallFromCallScreen) || this.validPausedVoiceMailRecording);
            },
            renderSaveStopButton() {
                return this.renderPhoneActionButtons && !this.isManualMode && !this.isLiveDashInboundCall && (!this.validVoiceMailRecording || this.missedCallFromCallScreen) && !this.validPausedVoiceMailRecording;
            },
            renderScheduledCommunicationForm() {
                return this.selectedCampaignDisposition?.campaign_disposition_id > 0 && this.selectedCampaignDisposition?.denotes_callback === true && this.communicationType === "Phone";
            },
            renderAppointmentCanceledForm() {
                return this.selectedCampaignDisposition?.campaign_disposition_id > 0 && this.selectedCampaignDisposition?.denotes_appointment_cancel === true;
            },
            renderAppointmentRescheduleForm() {
                return this.selectedCampaignDisposition?.campaign_disposition_id > 0 && this.selectedCampaignDisposition?.denotes_appointment_reschedule === true;
            },
            renderAlertOfLinkedDispositionFromPreviousAction() {
                return this.currentDispositionFromPreviousAction;
            },
            saveAndStopAction() {
                return this.accountPhoneSaveStop === "continue" ? "continue" : "stop";
            },
            // Mirrors the isOkayToSaveAndNext gates so a disabled Save always tells the agent why.
            // The stale-selection and missing-call cases are unrecoverable without a refresh (VE-10724).
            saveDisabledReason() {
                if (this.isOkayToSaveAndNext) {
                    return "";
                }

                if (this.selectedDispositionActionCampaignDispositionIds.length > 0 || this.queuedDispositionActionCampaignDispositionIds.length > 0) {
                    return "Complete the disposition actions above to save";
                }

                if (!(this.communicationDisposition?.campaign_disposition_id > 0)) {
                    return "Select a disposition to save";
                }

                if (this.communicationDisposition?.campaign_disposition_id !== this.selectedCampaignDisposition?.campaign_disposition_id) {
                    return "This disposition no longer matches the loaded customer. Re-select it, or refresh the Communication Center if it stays disabled.";
                }

                if (this.communicationType === "Phone" && !(this.callId > 0) && !this.callFailed) {
                    return "No call is attached to this disposition. Refresh the Communication Center to continue.";
                }

                if ((this.renderAppointmentForm || this.renderAppointmentRescheduleForm) && !this.validNewAppointment) {
                    return "Complete the appointment details to save";
                }

                if (this.renderAppointmentRescheduleForm && !(this.appointment?.datetime_changed === true)) {
                    return "Change the appointment date or time to save";
                }

                if (this.renderAppointmentCanceledForm && (!(this.appointment?.appointment_id > 0) && !(this.integrationAppointmentDetails?.appointment_id > 0))) {
                    return "Select the appointment to cancel to save";
                }

                if (this.renderScheduledCommunicationForm && (this.scheduledCommunication.scheduled_time_date === null || this.scheduledCommunication.scheduled_time_time === null || this.scheduledCommunication.time_zone_id === null)) {
                    return "Complete the scheduled communication details to save";
                }

                if (this.requiresDispositionActions && !this.areAllRequiredDispositionActionsFilled()) {
                    return "Complete the required disposition actions to save";
                }

                return "Save is unavailable. Refresh the Communication Center if it stays disabled.";
            },
            selectedDispositionActionCampaignDispositionIds() {
                const actionsWithDispositionType = this.dispositionActionValues?.filter(action => action.actionable_type === 'disposition');

                if (!actionsWithDispositionType || actionsWithDispositionType.length === 0) {
                    return [];
                }

                const filteredCampaignDispositions = this.campaignDispositions?.filter(disposition => actionsWithDispositionType.some(action => action.actionable_id === disposition.disposition_id));
                return filteredCampaignDispositions?.map(disposition => disposition.campaign_disposition_id) || [];

            },
            selectedDispositionHasSmsMessageFollowUp() {
                return this.selectedCampaignDisposition?.campaign_disposition_id > 0 && this.selectedCampaignDisposition?.has_sms_message_follow_up === true;
            },
            tekionActionsEnabled() {
                return this.isTekionEnabled && this.renderIntegrationAppointmentScheduler;
            },
            validCampaignCustomerActive() {
                return this.currentCampaignCustomer?.campaign_customer_active_id > 0;
            },
            validCampaignDispositions() {
                return (this.campaignDispositions?.length > 0);
            },
            validCommunicationDispositions() {
                return (this.communicationDispositions?.length > 0);
            },
            validNewAppointment() {
                // For reschedule appt, appointment ID must be present
                if (this.renderAppointmentRescheduleForm && !(this.appointment?.appointment_id > 0)) {
                    return false;
                }

                return !!this.appointment?.appointment_datetime_date && !!this.appointment?.appointment_datetime_time && this.appointment?.time_zone_id > 0 && this.appointmentIsUniqueIfRequired;
            },
            validPastAppointments() {
                return this.pastAppointments?.length > 0;
            },
            validPausedVoiceMailRecording() {
                return this.isPausedVoiceMailRecording === true;
            },
            validSetIsOkayToSaveAndNext() {
                return this.setIsOkayToSaveAndNext !== null && this.setIsOkayToSaveAndNext !== undefined;
            },
            validUpcomingAppointments() {
                return this.upcomingAppointments?.length > 0;
            },
            validVoiceMailRecording() {
                return this.voiceMailRecording?.voice_mail_recording_id > 0;
            },
        },
        components: {
            AppointmentCancelForm,
            AppointmentForm,
            AppointmentRescheduleForm,
            CommunicationDispositionDetails,
            ScheduledCommunicationForm,
            DispositionActionsForm,
            DispositionSelectChip,
        },
        props: {
            addSavedCommunicationDisposition: Function,
            appointmentIsUniqueIfRequired: Boolean,
            autobuyCommunicationDisposition: Object,
            callFailed: Boolean,
            callId: Number,
            callTransfer: Object,
            campaignDispositionToSurvey: Object,
            campaignId: Number,
            currentCampaignCustomer: Object,
            currentCampaignDisposition: Object,
            communicationManager: Object,
            communicationType: String,
            createAgent: Function,
            createSurveyAttempt: Function,
            finishSaveAndNextOverlay: Function,
            savedCommunicationDispositions: Array,
            initiateCreateCommunicationDisposition: Boolean,
            isManualMode: Boolean,
            isPausedVoiceMailRecording: Boolean,
            isSavedPlaceCall: Boolean,
            isTekionEnabled: Boolean,
            isLiveDashInboundCall: Boolean,
            missedCallFromCallScreen: Boolean,
            openTekionIntegrationTab: Function,
            parentDispositionNotes: String,
            pendingSavedPlaceCall: Object,
            reinitIntegrationCustomers: Function,
            renderIntegrationAppointmentScheduler: Boolean,
            resetCampaignDispositionToSurvey: Function,
            resetSavedCommunicationDispositions: Function,
            setAppointmentIsUniqueIfRequired: Function,
            setCampaignDispositions: Function,
            setChangeOnCurrentCampaignCustomer: Function,
            setIntegrationAppointmentDetails: Function,
            setIsOkayToCreateCommunicationDisposition: Function,
            setIsOkayToSaveAndNext: Function,
            setIsOkayToSurveySavedDisposition: Function,
            setSelectedCampaignDisposition: Function,
            setSubscriptionChangesOnCommunicationManager: Function,
            selectMostUsedDisposition: Boolean,
            showSnackbar: { type: Function, required: true },
            startSaveAndNext: Function,
            syncDispositionNotes: Function,
            integrationAppointmentDetails: Object,
            voiceMailRecording: Object,
        },
        watch: {
            "communicationDisposition.notes"() {
                if (this.syncDispositionNotes !== undefined) {
                    this.syncDispositionNotes(this.communicationDisposition?.notes);
                }
            },
            currentSelectedCampaignDispositionGroupId() {
                if (this.communicationDisposition) {
                    this.communicationDisposition.campaign_disposition_id = 0;
                }

                this.getCampaignDispositions(this.currentSelectedCampaignDispositionGroupId);
                this.handleMostUsedDispositionSelection();
            },
            pushAppointmentToTekion: {
                handler(newval, oldval) {
                    if (newval !== oldval && newval === true) {
                        this.openTekionIntegrationTab();
                    }
                }
            },
            integrationAppointmentDetails: {
                deep: true,
                immediate: true,
                handler() {
                    this.clearIntegrationAppointmentDispositionTimeout();

                    if (this.integrationAppointmentDetails?.appointment_id > 0) {

                        // set the best guess disposition for the action that happened in the integration tab
                        if (this.integrationAppointmentDetails?.action === "create") {
                            this.findAndSelectScheduleAppointmentCampaignDisposition();
                        } else if (this.integrationAppointmentDetails?.action === "cancel") {
                            this.findAndSelectCancelAppointmentCampaignDisposition();
                        }

                        // Todo: handle reschedule once its supported

                        if (this.initiateCreateCommunicationDisposition === true) {
                            return;
                        }

                        // wait 1 second before creating communication disposition so that fields get set properly in form
                        this.integrationAppointmentDispositionTimeoutId = setTimeout(() => {
                            this.integrationAppointmentDispositionTimeoutId = null;
                            this.createCommunicationDisposition();
                        }, 1000);
                    }
                },
            },
            initiateCreateCommunicationDisposition: {
                deep: true,
                immediate: true,
                handler() {
                    // If initiate is now true, create
                    if (this.initiateCreateCommunicationDisposition === true) {
                        this.createCommunicationDisposition();
                    }
                },
            },
            isOkayToCreateCommunicationDisposition() {
                this.setIsOkayToCreateCommunicationDisposition(this.isOkayToCreateCommunicationDisposition);
            },
            isOkayToSaveAndNext() {
                if (this.validSetIsOkayToSaveAndNext) {
                    this.setIsOkayToSaveAndNext(this.isOkayToSaveAndNext);
                }
            },
            isOkayToSurveySavedDisposition() {
                if (this.isValidToMultipleDisposition) {
                    this.setIsOkayToSurveySavedDisposition(this.isOkayToSurveySavedDisposition);
                }
            },
            parentDispositionNotes() {
                if (!!this.communicationDisposition && this.parentDispositionNotes !== this.communicationDisposition.notes) {
                    this.communicationDisposition.notes = this.parentDispositionNotes;
                }
            },
            renderAppointmentForm() {
                if (this.tekionActionsEnabled && this.pushAppointmentToTekion && this.renderAppointmentForm) {
                    this.openTekionIntegrationTab();
                }
            },
            selectedCampaignDisposition: {
                deep: true,
                immediate: true,
                handler() {
                    this.setSelectedCampaignDisposition(this.selectedCampaignDisposition);
                    this.getAppointmentSchedulingHours();
                    this.dispositionActionValues = [];
                },
            },
            selectMostUsedDisposition: {
                handler(newVal, oldVal) {

                    if (newVal && newVal !== oldVal) {
                        this.handleMostUsedDispositionSelection();

                        // select most used disposition is just a bool prop telling us whether or not the disposition tab is actually rendered
                        if (this.tekionActionsEnabled) {
                            this.pushAppointmentToTekion = true;
                            if (this.renderAppointmentForm) {
                                this.openTekionIntegrationTab();
                            }
                        }
                    }
                }
            },
        },
        created() {
            this.initNewCommunicationDisposition();
            this.init();
            this.getCommunicationDispositions();
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "newCommunicationDisposition" }}, this.onNewCommunicationDisposition);
        },
        destroyed() {
            this.clearIntegrationAppointmentDispositionTimeout();
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "newCommunicationDisposition" }}, this.onNewCommunicationDisposition);
        },
        beforeDestroy() {
            this.clearIntegrationAppointmentDispositionTimeout();
            this.currentDispositionFromPreviousAction = false;
        },
    });
</script>

<style lang="scss" scoped>
</style>
